(function () {
  function initContactForm(root) {
    var form = root.querySelector('[data-fw-contact-form]');
    if (!form || form.dataset.fwContactBound === 'true') return;
    form.dataset.fwContactBound = 'true';

    var topicSelect = form.querySelector('[data-fw-contact-topic]');
    var topicHidden = form.querySelector('[data-fw-contact-topic-value]');
    if (!topicSelect || !topicHidden) return;

    function syncTopic() {
      topicHidden.value = topicSelect.value || '';
    }

    topicSelect.addEventListener('change', syncTopic);
    form.addEventListener('submit', function () {
      syncTopic();
    });
  }

  function boot() {
    document.querySelectorAll('.fw-contact').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!(section instanceof Element)) return;
    section.querySelectorAll('.fw-contact').forEach(initContactForm);
  });
})();
